import React, { Component } from 'react';
import { Formik } from 'formik';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  Input,
  Button,
  Text,
  UserWarn,
  Row,
  Title,
  Label,
  Column,
} from '../../theme/index.js';
import loginButton from '../../../assets/loginButton.svg';
import { FORGOT_PASSWORD_SUCCESS } from './redux/actions';

const Wrapper = styled.div`
  width: 450px;
  height: 365px;
  background: #fff;
  margin-top: 12em;
  position: relative;
  border-radius: 6px;
  @media (max-width: 400px) {
    width: 350px;
  }
`;

const Form = styled.form`
  width: 100%;
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const StyledColumn = styled(Column)`
  width: 85%;
  margin: 0 auto;
  align-items: center;
  @media (max-width: 400px) {
    width: 95%;
  }
`;

class ForgotPasswordForm extends Component {
  state = { message: false, email: '' };
  render() {
    const { message } = this.state;

    return (
      <Wrapper>
        {message && (
          <Column
            alignitems="center"
            width="75%"
            margin="0 auto"
            textalign="center"
          >
            <Title>Success!</Title>
            <Text color="#2b2b2b">
              We have successfully sent you an email with password reset
              instructions
            </Text>
            {/* <Button
              home
              onClick={() => this.props.forgotPassword(this.state.email)}
            >
              Send again
            </Button> */}
          </Column>
        )}
        {!message && (
          <React.Fragment>
            <Title margin=".5em 0 .5em .75em">Change password</Title>
            <Formik
              initialValues={{
                email: '',
              }}
              validate={values => {
                let errors = {};
                if (!values.email) {
                  errors.email = 'An email is required';
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting, setErrors }) => {
                this.props
                  .forgotPassword(values)
                  .then(action => {
                    if (action.type === FORGOT_PASSWORD_SUCCESS) {
                      this.setState({
                        message: true,
                        email: values.email,
                      });
                      setSubmitting(false);
                    } else {
                      setSubmitting(false);
                      console.log(action.response.data);
                      // TODO fix this after fixing sending email on backend
                      let message = action.response.data;
                      setErrors({ error: message });
                    }
                  })
                  .catch(err => {
                    setSubmitting(false);
                    console.log('Error Logging in', err);
                  });
              }}
              render={({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <StyledColumn>
                    <Row alignitems="center" style={{ position: 'relative' }}>
                      {errors.error && <Text error>{errors.error}</Text>}
                    </Row>

                    <Row
                      alignitems="center"
                      justifycontent="center"
                      style={{ position: 'relative' }}
                    >
                      <Label htmlFor="email" login>
                        Email *
                        {touched.email && errors.email && (
                          <UserWarn>
                            <Text error>{errors.email}</Text>
                          </UserWarn>
                        )}
                        <Input
                          type="text"
                          name="email"
                          login
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          border={
                            (touched.email &&
                              errors.email &&
                              '1px solid red') ||
                            (errors.error && '1px solid red')
                          }
                        />
                      </Label>
                    </Row>
                  </StyledColumn>
                  <Button login type="submit">
                    <Icon src={loginButton} />
                  </Button>
                </Form>
              )}
            />
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

export default connect(
  null,
  {}
)(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/screens/ForgotPassword/ForgotPasswordForm.jsx